// Imports
import React, { useCallback, useMemo, useState } from "react"
import { withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { createSelector } from "reselect"
import TableContainer from "../../../../components/Common/TableContainer"
import ReportExcelExport from "../../../../components/Common/ReportExcelExport"
import { loadLedgerReportByDateRange as onLoadLedgerReportByDateRange } from "../../../../slice/thunks"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import GlobalLoader from '../../../../components/Common/GlobalLoader'
import moment from 'moment'
import { convertToDate } from "../../../../helpers/historyFile"


const Leger = ({ t = (key) => key }) => {
  const dispatch = useDispatch()

  const selectLayoutState = (state) => state.Outputs;
  const OutputsProperties = createSelector(
    selectLayoutState,
    (outputs) => ({
      reports: outputs.ledgerReports
    })
  )
  const { reports } = useSelector(OutputsProperties)

  const [isLoading, setIsLoading] = useState(false)
  const [dateRange, setDateRange] = useState([])
  const [localStartDate, setLocalStartDate] = useState(null)
  const [localEndDate, setLocalEndDate] = useState(null)

  const loadReportsByDateRange = useCallback((startDate, endDate) => {
    if (startDate && endDate) {
      setIsLoading(true)
      dispatch(onLoadLedgerReportByDateRange({
        startDate: startDate,
        endDate: endDate,
      })).finally(() => {
        setIsLoading(false)
      })
    }
  }, [dispatch])


  const handleDateSearch = () => {
    if (dateRange.length === 2) {
      setLocalEndDate(dateRange[1])
      setLocalStartDate(dateRange[0])
      loadReportsByDateRange(convertToDate(dateRange[0]), convertToDate(dateRange[1]))
    }
  }

  const columns = useMemo(() => [
    {
      header: t("s_slash_num"),
      style: "button",
      enableColumnFilter: false,
      cell: (cellProps) => (
        <span>{ cellProps.row.index + 1}</span>
      ),
    },
    {
      header: t("date"),
      style: "text-start",
      enableColumnFilter: false,
      cell: (cell) => (
        <span>
          {moment(localStartDate).format("DD/MM/YYYY")} - {moment(localEndDate).format("DD/MM/YYYY")}
        </span>
        )
    },
    {
      header: t("account_number"),
      accessorKey: "code",
      style: "text-start",
      enableColumnFilter: false,
    },
    {
      header: t("description"),
      accessorKey: "name",
      style: "text-start",
      enableColumnFilter: false,
    },
    {
      header: t("debit"),
      accessorKey: "debit",
      style: "debit",
      enableColumnFilter: false,
    },
    {
      header: t("credit"),
      accessorKey: "credit",
      style: "text-start",
      enableColumnFilter: false,
    },
     {
      header: t("balance"),
      accessorKey: "balance",
      style: "text-start",
      enableColumnFilter: false,
    },
  ], [t, localStartDate, localEndDate]);

  const totalDebit = useMemo(() => {
    return reports?.reduce((sum, { debit = 0 }) => sum + debit, 0) || 0;
  }, [reports]);

  const totalCredit = useMemo(() => {
    return reports?.reduce((sum, { credit = 0 }) => sum + credit, 0) || 0;
  }, [reports]);

  const totalBalance = useMemo(() => {
    return reports?.reduce((sum, { balance = 0 }) => sum + balance, 0) || 0;
  }, [reports]);

  return (
    <React.Fragment>
      {isLoading ? (
        <GlobalLoader />
      ) : (
        <div className="card ledger-content border-0 p-0 m-0" id="table1">
          <div className="container-fluide">
            <div className="row">
              <div className="pt-1">
                <div className="d-flex justify-content-between align-items-center mb-2 px-3">
                  <div className="d-flex align-items-center gap-2 me-3">
                    <Flatpickr
                      className="form-control date-range-picker"
                      options={{ mode: "range", dateFormat: "d-m-Y" }}
                      placeholder={t("select_date_range")}
                      value={dateRange}
                      onChange={setDateRange}
                      style={{
                        border: "1px solid #ccc",
                        margin: "7px",
                        marginTop: "10px",
                      }}
                    />
                    <button className="btn btn-primary d-inline-flex align-items-center" onClick={handleDateSearch}>
                      <i className="fa fa-search " /> {t("Search")}
                    </button>
                    {/* Appel du composant ReportExcelExport */}
                    <ReportExcelExport
                      title="Ledger"
                      data={reports}
                      columnsOrder={["code", "name", "debit", "credit", "balance"]}
                      totalFields={["debit", "credit", "balance"]}
                      dateRange={{ start: localStartDate, end: localEndDate }}
                    />
                  </div>
                </div>

                <TableContainer
                  columns={columns}
                  data={reports || []}
                  isGlobalFilter={false}
                  divClass="table-card-report"
                  tableClass="align-middle"
                  theadClass="thead-light table-light"
                  footer={
                    <tfoot className="table-light">
                      <tr>
                        <td colSpan="4" className="text-end fw-bold">{t("total")}</td>
                        <td className="fw-bold">{totalDebit.toLocaleString()}</td>
                        <td className="fw-bold">{totalCredit.toLocaleString()}</td>
                        <td className="fw-bold">{totalBalance.toLocaleString()}</td>
                      </tr>
                    </tfoot>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

export default withTranslation()(Leger)
